export default "__VITE_ASSET__DKt17A6v__"